import { Component, OnInit, Input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PartnerService } from '../../../services/partner.service';
import { CyclistService } from '../../../services/cyclist.service';
import { ServiceRequestService } from '../../../services/servicerequest.service';
import { HelpersService } from '../../../services/helpers.service';
import { BikeService } from '../../../services/bike.service';
import { ProductsService } from '../../../services/products.service';
import { PosIntegrationService } from '../../../services/pos-integration.service';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import {
  Validators,
  FormControl,
  FormGroup,
  FormBuilder,
  AbstractControl,
  ValidatorFn,
} from '@angular/forms';

@Component({
  selector: 'app-record-bike-sale',
  templateUrl: './record-bike-sale.component.html',
  styleUrls: ['./record-bike-sale.component.scss'],
  providers: [MessageService],
})
export class RecordBikeSaleComponent implements OnInit {
  @Input() partnerId;
  @Input() messageService: MessageService;
  public search: string = '';
  public noCyclist = false;
  public cyclists: any = null;
  public selectedCyclist: any = {};
  public step: number = 1;
  public submitting: boolean = false;
  public searching: boolean = false;
  public addNewCyclist: boolean = false;
  public products: any = [];
  public searchResult: any = [];
  public selectedBike: any = {};
  public partnerData: any = {};
  public currencySymbol = '';
  public VATInclusive = true;
  public VATRate = 0.15;
  public buttonDisabled = false;
  public bikeForm: FormGroup;
  public ManufacturerSKU: string = '';
  public loading = false;
  public syncingPOS: boolean = false;
  public employees: any[];
  public showAddBikeForm: boolean = true;
  public allowEmployeeSelection: boolean = false;
  public salesPersonID: string = null;
  public bikes: any = [];

  constructor(
    public modal: NgbActiveModal,
    public partnerService: PartnerService,
    public cyclistService: CyclistService,
    public serviceRequest: ServiceRequestService,
    public datePipe: DatePipe,
    public helpersService: HelpersService,
    public bikeService: BikeService,
    private translate: TranslateService,
    public fb: FormBuilder,
    public productsService: ProductsService,
    private posIntegrationService: PosIntegrationService,
  ) {
    this.products = [...this.helpersService.getProductData()];
    this.initiateBikeForm();
  }

  ngOnInit() {
    const partnerData = this.helpersService.getPartnerData();
    this.currencySymbol = partnerData.CurrencySymbol;
    this.VATInclusive = partnerData.VATInclusive;
    this.VATRate = partnerData.VATRate;

    this.partnerData = partnerData;

    if ([3, 6].indexOf(partnerData.POSSystemID) > -1) {
      //LS and Vend
      if (partnerData.POSSystemID === 3) {
        this.posIntegrationService
          .getVendUsers(this.partnerId)
          .subscribe((users) => {
            this.allowEmployeeSelection = true;
            this.employees = users.map((x) => {
              return { value: x.Data, label: x.Description };
            });
          });
      } else if (partnerData.POSSystemID === 6) {
        this.posIntegrationService
          .getLightspeedUsers(this.partnerId)
          .subscribe((users) => {
            this.allowEmployeeSelection = true;
            this.employees = users.map((x) => {
              return { value: x.ID, label: x.Description };
            });
          });
      }
    }
  }

  initiateBikeForm() {
    this.bikeForm = this.fb.group({
      product: new FormControl(
        '',
        Validators.compose([Validators.required, this.productCheck()]),
      ),
      manufacturer: new FormControl('', Validators.required),
      model: new FormControl('', Validators.required),
      modalYear: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.maxLength(4),
          Validators.minLength(4),
          Validators.pattern('^[0-9]+$'),
        ]),
      ),
      datePurchased: new FormControl(new Date(), Validators.required),
      serialNumber: new FormControl(''),
    });

    if (this.partnerData.POSSystemID > 0) {
      this.bikeForm.reset({
        manufacturer: { value: '', disabled: true },
        model: { value: '', disabled: true },
        modalYear: { value: '', disabled: true },
        datePurchased: { value: '', disabled: true },
        serialNunber: { value: '', disabled: true },
      });
    }
  }

  productCheck(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      return this.partnerData.POSSystemID < 0 ||
        (control.value && control.value.SKU)
        ? null
        : { invalidPassword: true };
    };
  }

  next = () => {
    this.step = this.step + 1;
  };

  nextCyclist = (user) => {
    this.selectedCyclist = user;
    this.step = this.step + 1;
  };

  back() {
    this.step = this.step - 1;
  }

  addBike(addnew = true) {
    this.bikes = [
      ...this.bikes,
      {
        SerialNumber: this.bikeForm.value.serialNumber,
        Manufacturer: this.bikeForm.value.manufacturer,
        Model: this.bikeForm.value.model,
        Image: this.selectedBike.image || '',
        Colour: '',
        Year: this.bikeForm.value.modalYear,
        DateBought: this.helpersService.convertDate(
          this.bikeForm.value.datePurchased,
        ),
        OpeningHours: 0,
        OpeningKm: 0,
        Sku: this.bikeForm.value.product.SKU,
        Product: this.bikeForm.value.product,
      },
    ];
    this.showAddBikeForm = false;
    this.initiateBikeForm();
    if (addnew) {
      setTimeout(() => {
        this.showAddBikeForm = true;
      }, 200);
    }
  }

  deleteLineItem(index) {
    this.bikes.splice(index, 1);
  }

  recordSale() {
    if (
      this.bikeForm.value.product &&
      this.bikeForm.value.manufacturer &&
      this.bikeForm.value.manufacturer.length > 0
    ) {
      this.addBike(false);
    }

    let bike = {
      Email: this.selectedCyclist.Email,
      PhoneNumber: this.selectedCyclist.PhoneNumber,
      UserID: this.selectedCyclist.ID,
      PartnerId: this.partnerId,
      SalesPersonID: this.salesPersonID,
      Bikes: this.bikes,
    };
    this.buttonDisabled = true;
    this.bikeService.bikeSale(bike).subscribe(
      (newBike) => {
        this.buttonDisabled = false;
        this.messageService.add({
          life: 2000,
          detail: this.translate.instant(
            'bikeshop.bike_sale.bike_has_been_sold',
          ),
        });
        this.modal.close();
      },
      (error) => {
        this.buttonDisabled = false;
        console.log(error);
      },
    );
  }

  searchCyclist() {
    this.noCyclist = false;
    this.cyclists = null;
    this.selectedCyclist = {};
    this.searching = true;
    this.addNewCyclist = false;
    console.log(this.search);
    this.cyclistService
      .searchCyclist(this.partnerId, this.search)
      .subscribe((cyclists) => {
        this.cyclists = [];
        cyclists.forEach((cyclist) => {
          this.cyclists.push({
            label:
              cyclist.Name + ' ' + cyclist.Surname + ' (' + cyclist.Email + ')',
            value: cyclist,
          });
        });
        if (this.cyclists.length > 0) {
          this.selectedCyclist = this.cyclists[0].value;
        } else {
          this.searching = false;
          this.noCyclist = true;
        }
      });
  }

  createNewCyclistForm() {
    this.cyclists = [];
    this.selectedCyclist = {};
    this.searching = false;
    this.noCyclist = true;
    this.search = '';
  }

  addCyclist() {
    this.selectedCyclist = {};
    this.cyclists = null;

    setTimeout(() => {
      this.cyclists = [];
      this.addNewCyclist = true;
      this.searching = false;
    }, 1000);
  }

  newCyclist(event) {
    if (event.searchAgain) {
      this.search = event.cyclist.Email;
      this.searchCyclist();
    } else {
      this.selectedCyclist = event.cyclist;
      if (this.selectedCyclist) {
        this.next();
      } else {
        this.search = event.cyclist.Email;
        this.searchCyclist();
      }
    }
  }

  onSelect(event) {
    if (event.value) {
      event = event.value;
    }
    if (
      [3, 6].indexOf(this.partnerData.POSSystemID) > -1 &&
      (event.ExternalProductID === null ||
        event.ExternalProductID === undefined)
    ) {
      this.productsService
        .searchInvoiceProduct(this.partnerId, event.SKU)
        .subscribe((result) => {
          let products = result.filter((item) => {
            return item.Name === event.Name;
          });
          if (products.length > 0) {
            let product = products[0];
            product.InternalProductID = JSON.parse(JSON.stringify(product)).ID;
            product.ID = 0;
            product.Quantity = null;
            product.OriginalUnitPrice = JSON.parse(
              JSON.stringify(product),
            ).UnitPrice;
            delete product.PartnerID;
            this.onSelect(product);
          }
        });
      return;
    }

    this.bikeForm.reset({
      product: event,
      manufacturer: { value: '', disabled: false },
      model: { value: '', disabled: false },
      modalYear: { value: '', disabled: false },
      datePurchased: { value: new Date(), disabled: false },
    });

    if (event.Brand) {
      this.bikeForm.patchValue({ manufacturer: event.Brand });
    }
    if (event.ManufacturerSKU) {
      this.ManufacturerSKU = event.ManufacturerSKU;
      this.loading = true;
      this.bikeService.getBikeDetails(event.ManufacturerSKU).subscribe(
        (res) => {
          this.bikeForm.patchValue({ ...res, manufacturer: 'Specialized' });
          this.selectedBike = res;
          this.selectedBike.manufacturer = 'Specialized';
          this.loading = false;
        },
        (err) => {
          this.loading = false;
        },
      );
    }

    if (
      [3, 6].indexOf(this.partnerData.POSSystemID) > -1 &&
      event.ExternalProductID
    ) {
      //LS and Vend
      this.productsService
        .getQtyPerProduct(this.partnerId, event.ExternalProductID)
        .subscribe((results) => {
          var product = results
            .filter((x) => {
              return x.ID === event.ExternalProductID;
            })
            .pop();
          console.log(product);
          if (product) {
            this.bikeForm.patchValue({
              product: { ...event, Quantity: product.Quantity },
            });
          }
        });
    }
  }

  filterList(q, list) {
    function escapeRegExp(s) {
      return s.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    const words = q
      .split(/\s+/g)
      .map((s) => s.trim().toLowerCase())
      .filter((s) => !!s);

    const hasTrailingSpace = q.endsWith(' ');
    const searchRegex = new RegExp(
      words
        .map((word, i) => {
          if (words.length === 1) {
            return `(.*${escapeRegExp(word)}.*)`;
          } else {
            return `(?=.*\\b${escapeRegExp(word)})`;
          }
        })
        .join(''),
      'gi',
    );

    var resultList = list.filter((item) => {
      return searchRegex.test(item.Name);
    });

    resultList.forEach((res) => {
      var nameArray = res.Name.split(' ');
      var count = 0;
      nameArray.forEach((name) => {
        if (words.includes(name.toLowerCase())) {
          count += 1;
        }
      });
      res.wordMatch = count;
    });

    resultList = resultList.sort((a, b) => {
      if (a.wordMatch > b.wordMatch) {
        return -1;
      } else if (a.wordMatch < b.wordMatch) {
        return 1;
      } else {
        return 0;
      }
    });

    return resultList;
  }

  searchProducts(event) {
    //Return no resilts for 1 letter... this can slow browser allot. Might want to increase this if too many results get shown
    if (event.query.length < 2) {
      this.searchResult = [];
      return;
    }

    //Try search the SKU type fields 1st
    var results = this.products.filter(function (product) {
      return (
        product.SKU.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        //product.Name.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        (!!product.SystemSKU &&
          product.SystemSKU.toLowerCase().indexOf(event.query.toLowerCase()) >
            -1) ||
        (!!product.ManufacturerSKU &&
          product.ManufacturerSKU.toLowerCase().indexOf(
            event.query.toLowerCase(),
          ) > -1) ||
        (!!product.UPC &&
          product.UPC.toLowerCase().indexOf(event.query.toLowerCase()) > -1) ||
        (!!product.EAN &&
          product.EAN.toLowerCase().indexOf(event.query.toLowerCase()) > -1) ||
        (!!product.CustomSKU &&
          product.CustomSKU.toLowerCase().indexOf(event.query.toLowerCase()) >
            -1)
      );
    });

    //Use a different search to filter the Name field, this now can search the field with words in any order.
    var nameResults = this.filterList(event.query, this.products);
    if (nameResults && nameResults.length > 0) {
      nameResults.forEach((result) => {
        if (
          results.filter((x) => {
            return x.ID == result.ID;
          }).length === 0
        ) {
          results.push(result);
        }
      });
    }

    results = JSON.parse(JSON.stringify(results)).map((product) => {
      product.InternalProductID = JSON.parse(JSON.stringify(product)).ID;
      product.ID = 0;
      product.Quantity = null;
      product.OriginalUnitPrice = JSON.parse(JSON.stringify(product)).UnitPrice;
      delete product.PartnerID;
      return product;
    });

    if (results.length > 0) {
      this.searchResult = results;
    } else {
      this.searchExternal(event);
    }
  }

  searchExternal(event) {
    this.productsService.searchProduct(this.partnerId, event.query).subscribe(
      (results) => {
        if (results.length === 0 && event.query.length > 4) {
          event.query = event.query.substr(0, event.query.length - 1);
          this.searchProducts(event);
        } else {
          this.searchResult = results.map((item) => {
            return {
              ID: item.ID,
              SKU: item.Description,
              Name: item.Data,
              Quantity: null,
              OriginalUnitPrice: JSON.parse(JSON.stringify(item)).UnitPrice,
              UnitPrice: JSON.parse(JSON.stringify(item)).UnitPrice,
              UnitPrice_IncludingTax: JSON.parse(JSON.stringify(item))
                .UnitPrice_IncludingTax,
            };
          });
        }
      },
      (err) => {
        if (err && event.query.length > 4) {
          event.query = event.query.substr(0, event.query.length - 1);
          this.searchProducts(event);
        }
      },
    );
  }

  syncPOS() {
    this.syncingPOS = true;
    this.posIntegrationService.startPOSSync(this.partnerId).subscribe(
      (syncRes) => {
        this.productsService.getAllProducts(this.partnerId).subscribe(
          (products) => {
            this.helpersService.saveProductData(products);
            this.products = products;

            this.syncingPOS = false;
            this.messageService.add({
              life: 5000,
              detail: this.translate.instant(
                'bikeshop.modal.update_job_card.quote.pos_sync_complete',
              ),
            });
          },
          (err) => {
            this.syncingPOS = false;
          },
        );
      },
      (err) => {
        this.syncingPOS = false;
      },
    );
  }
}
